import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

const DashboardMessageView = props => (
  <div className="card py-5">
    <div className="d-flex flex-column justify-content-center align-items-center">
      {props.icon}
      <strong style={{fontSize: '30px'}}>
        <Translate value={props.title}/>
      </strong>
      <p style={{textAlign: 'center'}}>
        <Translate value={props.message}/>
      </p>
      {props.onClickButton &&
        <button
          className="primary large mt-5"
          onClick={props.onClickButton}
        >
          <Translate value={props.buttonLabel}/>
        </button>
      }
    </div>
  </div>
);

DashboardMessageView.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  onClickButton: PropTypes.func
};

export default DashboardMessageView;
